import { create } from 'zustand';

type Telefone = {
  tipo: string;
  telefone: string;
};

export type Dentist = {
  idFuncionario: number;
  nomeFantasia: string;
  endereco: string;
  bairro: string;
  cep?: string;
  cidade?: string;
  uf?: string;
  telefone: Telefone[];
  latitude: string;
  longitude: string;
  especialidades?: string;
};

export type Clinica = {
  clinicaId: number;
  nomeFantasia: string;
  endereco: string;
  bairro: string;
  municipio: string;
  uf: string;
  cep: string;
  telefone: string;
  latitude: string;
  longitude: string;
  dentistas: Dentist[];
};

type Store = {
  clinicas: Clinica[];
  total: number;
  paginaAtual: number;
  loading: boolean;
  selectedDentist: Dentist | null;
  setSelectedDentist: (dentist: Dentist) => void;

  setClinicas: (clinicas: Clinica[]) => void;
  setTotal: (total: number) => void;
  setPaginaAtual: (pagina: number) => void;
  setLoading: (loading: boolean) => void;

  fetchData: (params: {
    stateId: number;
    cityId: number;
    specialtyId: number;
  }) => Promise<void>;
};

export const useDentistStore = create<Store>((set, get) => ({
  clinicas: [],
  total: 0,
  paginaAtual: 1,
  loading: false,
  selectedDentist: null,
  setSelectedDentist: dentist => set({ selectedDentist: dentist }),

  setClinicas: clinicas => set({ clinicas }),
  setTotal: total => set({ total }),
  setPaginaAtual: paginaAtual => set({ paginaAtual }),
  setLoading: loading => set({ loading }),

  fetchData: async ({ stateId, cityId, specialtyId }) => {
    const { paginaAtual } = get();

    try {
      set({ loading: true });

      const res = await fetch(
        `${process.env.REACT_APP_OG_API_URL}/info/RedeVendas?` +
          `ufId=${stateId}&municipioId=${cityId}&especialidadeId=${specialtyId}` +
          `&quantidade=5&page=${paginaAtual}`,
      );

      if (!res.ok) throw new Error('Erro na requisição');

      const data = await res.json();

      set({ clinicas: data.items, total: data.total });
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      set({ loading: false });
    }
  },
}));

type selectedDentistState = {
  data: any;
  setselectedDentistData: (data: boolean) => void;
};

export const useSelectedDentistDataStore = create<selectedDentistState>(
  (set, get) => ({
    data: {},
    setselectedDentistData: data => set(() => ({ data: data })),
    action: () => {
      const data = get().data;
    },
  }),
);
type totalclinicState = {
  data: number;
  setTotalClinicData: (data: number) => void;
};

export const useTotalClinicDataStore = create<totalclinicState>((set, get) => ({
  data: 0,
  setTotalClinicData: data => set(() => ({ data: data })),
  action: () => {
    const data = get().data;
  },
}));
